import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';

export class MedicalRecordGeneralInformationModel extends WithPermissionModel{

    id: number;
    partner: PartnerSummaryModel;
    cardiac: boolean;
    diabetic: LovValueSummary;
    hemophiliac: boolean;
    arteritic: boolean;
    shoeSize: number;
    height: number;
    weight: number;
    securityNumber: string;
    jobRemark: string;
    job: string;

    allergies: LovValueSummary[] = [];
    allergyComment: string;
    medications: LovValueSummary[] = [];
    medicationComment: string;

    senseTroubles: LovValueSummary[] = [];
    senseTroubleComment: string;

    poisonings: LovValueSummary[] = [];
    poisoningComment: string;

    shoeType: LovValueSummary;

    dominantFoot: LovValueSummary;
    dominantHand: LovValueSummary;
}
